 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0,
 		2: 0,
 		3: 0,
 		4: 0,
 		5: 0,
 		6: 0,
 		7: 0,
 		8: 0,
 		9: 0,
 		10: 0,
 		11: 0,
 		12: 0,
 		13: 0,
 		14: 0,
 		15: 0,
 		16: 0,
 		17: 0,
 		19: 0,
 		20: 0,
 		21: 0,
 		22: 0,
 		23: 0,
 		25: 0,
 		26: 0,
 		27: 0,
 		28: 0,
 		29: 0,
 		30: 0,
 		31: 0,
 		32: 0,
 		35: 0,
 		42: 0,
 		43: 0,
 		44: 0,
 		45: 0,
 		46: 0,
 		47: 0,
 		48: 0,
 		49: 0,
 		50: 0,
 		51: 0,
 		53: 0,
 		54: 0,
 		55: 0,
 		56: 0,
 		57: 0,
 		58: 0,
 		59: 0,
 		60: 0,
 		61: 0,
 		62: 0,
 		63: 0,
 		64: 0,
 		65: 0,
 		66: 0,
 		67: 0,
 		68: 0,
 		69: 0,
 		70: 0,
 		71: 0,
 		72: 0,
 		73: 0,
 		74: 0,
 		75: 0,
 		76: 0,
 		77: 0,
 		78: 0,
 		79: 0,
 		80: 0,
 		81: 0,
 		82: 0,
 		83: 0,
 		84: 0,
 		85: 0,
 		86: 0,
 		87: 0,
 		88: 0,
 		89: 0,
 		90: 0,
 		91: 0,
 		92: 0,
 		93: 0,
 		94: 0,
 		95: 0,
 		96: 0,
 		97: 0,
 		98: 0,
 		99: 0,
 		100: 0,
 		101: 0,
 		102: 0,
 		103: 0,
 		104: 0,
 		105: 0,
 		106: 0,
 		107: 0,
 		108: 0,
 		109: 0,
 		110: 0,
 		111: 0,
 		112: 0,
 		113: 0,
 		114: 0,
 		115: 0,
 		116: 0,
 		117: 0,
 		118: 0,
 		119: 0,
 		120: 0,
 		121: 0,
 		122: 0,
 		123: 0,
 		124: 0,
 		125: 0,
 		126: 0,
 		127: 0,
 		128: 0,
 		129: 0,
 		130: 0,
 		131: 0,
 		132: 0,
 		133: 0,
 		134: 0,
 		135: 0,
 		136: 0,
 		137: 0,
 		138: 0,
 		139: 0,
 		140: 0,
 		141: 0,
 		142: 0,
 		143: 0,
 		144: 0,
 		145: 0,
 		146: 0,
 		147: 0,
 		148: 0,
 		150: 0,
 		151: 0,
 		152: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"160":"vendors~chartjs"}[chunkId]||chunkId) + "-" + {"160":"4719fd8de34eab4ef2ba"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//d2c4lrke06p7hp.cloudfront.net/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 331);
